import getWallet from "./wallet";
import abi from "../abi/token.json";
import { ethers } from "ethers";

// Polygon Mainnet
const tokenAddress = "0xc2132D05D31c914a87C6611C10748AEb04B58e8F";

// Amoy
// const tokenAddress = "0xBc66F6aC85178381917Ca1DE7b763c4446D00A1f";

// Local
// const tokenAddress = "0x5FbDB2315678afecb367f032d93F642f64180aa3";

const getTokenContract = async () => {
    const wallet = await getWallet();
    let contract = new ethers.Contract(tokenAddress, abi, wallet.provider);
    if(!wallet.isReadOnly) {
        contract = contract.connect(wallet.signer);
    }
    return contract;
}

export default getTokenContract;